import cs from 'classnames';
import { type VideoHTMLAttributes, forwardRef } from 'react';
import { Text } from '../typography';

const VideoPlayer = forwardRef<HTMLVideoElement, VideoHTMLAttributes<HTMLVideoElement>>(
  ({ children, className, ...rest }, reference) => (
    // eslint-disable-next-line jsx-a11y/media-has-caption -- We don't have captions for those videos
    <video className={cs('video-player-ui', className)} controls ref={reference} {...rest}>
      {children}
      <Text>Your browser does not support the video tag.</Text>
    </video>
  ),
);

export default VideoPlayer;
